module.exports = __webpack_public_path__ + "media/images/clients/friend-58896aee26ba0b5fcef54393d784c9d5.svg";